import { trace } from 'rytm-helpers'
import { TweenMax, TimelineMax, Power0, Power1, Power2, Power3, Power4, Back, Bounce, Elastic, Expo, Sine } from 'gsap'
import { updateLocomotiveScroll } from './../scroll'

const GLO_ANIMATE_SELECTOR = ".glo-animate"
const CLASS_NAME_ACTIVATED = "glo-animate-triggered"

export const initGloAnimate = (args) => {
  // carousel event listeners
  document.addEventListener("slide.bs.carousel", onBsCarouselSlide)
}
// update on scroll
export const updateGloAnimate = (args) => {
  const list = [...document.querySelectorAll(GLO_ANIMATE_SELECTOR)]
  list.forEach( checkGloAnimateEl )
}
// check element status
const checkGloAnimateEl = (el, index) => {
  if (el.classList.contains("is-inview")) {
    if (!el.classList.contains(CLASS_NAME_ACTIVATED)) {
      el.classList.add(CLASS_NAME_ACTIVATED)
      animShow(el, index)
    }
  } else {
    if (el.classList.contains(CLASS_NAME_ACTIVATED)) {
      el.classList.remove(CLASS_NAME_ACTIVATED)
      animHide(el, index)
    }
  }
}
// animate element IN (show)
const animShow = (el, index) => {
  // trace("animate show", el, index)
  if (el.classList.contains("benefits")) {
    animShowBenefits(el, index)
  } else if (el.classList.contains("glo-siv-icon")) {
    animShowSivIcon(el, index)
  } else if (el.classList.contains("glo-siv-scale")) {
    animShowSivScale(el, index)
  } else if (el.classList.contains("glo-siv")) {
    animShowSiv(el, index)
  }
}
// animate element OUT (hide)
const animHide = (el, index) => {
  // trace("animate hide", el, index)
}

// anim IN (show) SIV
const animShowSiv = (el, index) => {
  const delay = index * .07
  TweenMax.killTweensOf(el)
  TweenMax.set(el, {opacity: 0})
  TweenMax.to(el, .6, {opacity: 1, delay})
}
// anim IN (show) SIV-scale
const animShowSivScale = (el, index) => {
  const delay = 0.4
  TweenMax.killTweensOf(el)
  TweenMax.set(el, {opacity: 0, scale: .1})
  TweenMax.to(el, .6, {opacity: 1, scale: 1, delay, ease: Back.easeOut})
}
// anim IN (show) SIV-icon
const animShowSivIcon = (el, index) => {
  const delay = index * .07
  const icon = el.querySelector(".icon-wrapper")
  TweenMax.killTweensOf(el)
  TweenMax.killTweensOf(icon)
  TweenMax.set(el, {opacity: 0})
  TweenMax.set(icon, {opacity: 0, scale: .5})
  TweenMax.to(el, .2, {opacity: 1, delay})
  TweenMax.to(icon, .4, {opacity: 1, scale: 1, delay: delay + .2, ease: Back.easeOut})
}

// animate Benefits IN (show)
const animShowBenefits = (el, index) => {
  const list = [...el.querySelectorAll("p")]
  list.forEach((it, i) => {
    animShowBenefitsRow(it, i)
  })
}
const animShowBenefitsRow = (el, index) => {
  const delay = index * .07 + .3
  TweenMax.killTweensOf(el)
  TweenMax.set(el, {opacity: 0})
  TweenMax.to(el, 1.3, {opacity: 1, delay})
  const perc = el.querySelector("strong")
  if (perc) {
    if (perc.dataset.oryginalValue) {
      perc.innerHTML = perc.dataset.oryginalValue
    } else {
      perc.dataset.oryginalValue = perc.innerHTML
    }
    const hasPercSymbol = perc.innerHTML.indexOf("%") >= 0
    let it = {
      value: parseInt(perc.innerHTML)
    }
    TweenMax.from(it, 1.4, {value: 0, roundProps: 'value', delay, ease: Sine.easeOut, onUpdate: () => {
      const txt = it.value + (hasPercSymbol ? '%' : '')
      perc.innerHTML = txt
    }})
  }
}


// DOM events
const onBsCarouselSlide = (e) => {
  const nextSlide = e.target.querySelector(".carousel-item:nth-child(" + (e.to + 1) + ")")
  const list = nextSlide ? [...nextSlide.querySelectorAll(GLO_ANIMATE_SELECTOR)] : []
  list.forEach( (el, index) => {
    el.classList.remove(CLASS_NAME_ACTIVATED)
    el.classList.add("is-inview")
    checkGloAnimateEl(el, index)
  } )
}